module.exports = "/_next/static/images/detectiveAvatar-d8502431e0d8866a58f645e597a54597.png";